import { httpClient } from "@services/api/httpClient";

interface GetOfferParams {
  id: number
}

export async function getOffer({id }: GetOfferParams) {
  const response = await httpClient.get("/offer/get", {
    params: { id }
  });
  return response.data;
}